var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompanyInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.286,
    height: 29.279,
    viewBox: "0 0 29.286 29.279",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info",
    transform: "translate(-768.35 -326.931)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M783.909,356.21h-1.831a1.71,1.71,0,0,0-.22-.047,13.449,13.449,0,0,1-4.5-1.086,14.452,14.452,0,0,1-8.783-10.986c-.1-.53-.151-1.071-.224-1.608v-1.831c.017-.092.037-.184.051-.277.109-.705.168-1.421.332-2.113a14.642,14.642,0,0,1,28.895,2.726,14.655,14.655,0,0,1-12.11,15C784.984,356.082,784.445,356.137,783.909,356.21Zm-13.271-14.654a12.356,12.356,0,1,0,12.381-12.342A12.355,12.355,0,0,0,770.638,341.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M947.325,492.117c0,1.219,0,2.439,0,3.657a1.135,1.135,0,0,1-.884,1.122,1.115,1.115,0,0,1-1.255-.571,1.348,1.348,0,0,1-.141-.573q-.014-3.658,0-7.316a1.142,1.142,0,1,1,2.284-.007C947.33,489.659,947.325,490.889,947.325,492.117Z",
    transform: "translate(-163.187 -148.088)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M939.81,430.16a1.544,1.544,0,0,1,3.087.018,1.544,1.544,0,1,1-3.087-.018Z",
    transform: "translate(-158.36 -93.929)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyInfo);
export default __webpack_public_path__ + "static/media/company_info.687ee92edb3397b4a36ffc096ef7a3f2.svg";
export { ForwardRef as ReactComponent };